import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-participation',
  templateUrl: './participation.component.pug',
  styleUrls: ['./participation.component.scss'],
  standalone: false
})
export class ParticipationComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  constructor() { }
  state = 'participated'
  previousState = '';

  switchState(newState) {
    if(this.previousState !== newState) {
      this.state = newState;
      this.previousState = newState;
    }
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
  }

}
